import http from 'http'

const state = {
}

const getters = {}

const mutations = {
}

const actions = {
  /**
   * 获取任务列表
   */
  async getTasksByInfrared ({ commit }) {
    try {
      return await http.infrared.findTasksByInfrared()
    } catch (e) {
      throw new Error(e)
    }
  },

  /**
   * 获取红外模块老化测试详情（后面跟任务id）
   * @param {*String} id 任务id
   * @param {*String} options.countPerRow 每排单侧设备数量
   */
  async getTestDetile ({ commit }, options) {
    try {
      return await http.infrared.findTestDetile(options)
    } catch (e) {
      throw new Error(e)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
